import * as t from 'io-ts';
import { createLocalStorageItem } from 'src/domains/layouts/state/localStorage/createLocalStorageItem';
import { LocalStorageItemState } from 'src/domains/layouts/state/localStorage/LocalStorageItemState';
import { buildValidator } from 'src_common/common/mobx-utils/buildValidator';

const decodeIO = t.union([t.union([t.literal('debit-card'), t.literal('apple-pay'), t.literal('yaspa')]), t.null]);

const decode = buildValidator('localStoragePaymentMethod.decodeIO', decodeIO, true);

export const localStoragePaymentMethod = (
    withAutorun: boolean,
    key: string
): LocalStorageItemState<'debit-card' | 'apple-pay' | 'yaspa' | null> => {
    return createLocalStorageItem(withAutorun, {
        key: key,
        decode: decode,
        defaultValue: null,
    });
};
